// src/pages/hotelMealPlans/CreateHotelMealPlan.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditHotelMealPlan from "../../components/hotelMealPlans/FormAddEditHotelMealPlan";
import { useNavigate } from "react-router-dom";

const CreateHotelMealPlan = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditHotelMealPlan
                isEdit={false}
                onSubmitSuccess={() => navigate("/hotel-meal-plans")}
            />
        </WrapperSection>
    );
};

export default CreateHotelMealPlan;
